import axios from "axios";
// import envInstants from "../../libs/configs/env";

const apiExcept = "auth/login";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
});

instance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response);
    }),
  (error) => {
    // ไม่มี response (network error / timeout / เซิร์ฟเวอร์ล่ม) — ไม่มีสถานะให้ตรวจสอบ
    // ส่ง error ต่อให้ผู้เรียกจัดการ กัน interceptor throw เองจาก error.response ที่เป็น undefined
    // (สาเหตุหนึ่งที่ทำให้หน้าเว็บค้างจนต้อง refresh)
    if (!error.response) {
      return Promise.reject(error);
    }
    const _url = error.response.config?.url || '';
    if (_url.indexOf(apiExcept) === -1) {
      if (error.response.status === 401) {
        const getRefreshToken = async () => {
          try {
            const res = await axios.get(
              localStorage.getItem("url") + "auth/refresh",
              {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("refreshTR"),
                },
              }
            );
            const data = await res.data;

            if (data.status === true) {
              axios.interceptors.request.use(
                (config) => {
                  if (res.data.result.accessToken) {
                    config.headers.authorization = `Bearer ${res.data.result.accessToken}`;
                  }
                  return config;
                },
                (error) => {
                  return Promise.reject(error);
                }
              );
              window.location.reload()
              localStorage.setItem("accessTR", res.data.result.accessToken);
              localStorage.setItem("refreshTR", res.data.result.refreshToken);
            }
          } catch {
            localStorage.clear('refreshTR')
            localStorage.clear('accessTR')
            window.location.href = '/login'
          }
        };

        getRefreshToken();
      } else {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
    }
  }
);


export default instance;

export function setDefaultURL(url) {

  instance.defaults.baseURL = url;

}


